import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import API_URL from "../../config";

const EditCandidate = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [candidate, setCandidate] = useState({
        name: "",
        email: "",
        phone: "",
        qualification: "",
        experience_years: "",
        skills: "",
        location: "",
        bio: "",
        profile_pic: ""
    });

    useEffect(() => {
        fetchCandidate();
    }, []);

    const fetchCandidate = async () => {
        try {

            const response = await axios.get(
                `${API_URL}/admin/candidates/${id}`
            );

            setCandidate(response.data.data);

        } catch (err) {

            console.error(err);

            alert("Unable to load candidate.");

        } finally {

            setLoading(false);

        }
    };

    const handleChange = (e) => {

        setCandidate({
            ...candidate,
            [e.target.name]: e.target.value
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await axios.put(
                `${API_URL}/admin/candidates/${id}`,
                candidate
            );

            alert("Candidate updated successfully.");

            navigate("/admin/candidates");

        } catch (err) {

            console.error(err);

            alert("Update failed.");

        }

    };

    if (loading) {
        return (
            <Loader
                fullScreen
                text="Loading Candidate..."
            />
        );
    }

    return (

        <div className="space-y-6">

            <PageHeader
                title="Edit Candidate"
                subtitle="Update candidate details"
                showButton={false}
                breadcrumb={[
                    { label: "Dashboard", link: "/admin" },
                    { label: "Candidates", link: "/admin/candidates" },
                    { label: "Edit Candidate" }
                ]}
            />

            <div className="bg-white rounded-3xl shadow-lg p-8">

                <form
                    onSubmit={handleSubmit}
                    className="grid grid-cols-1 md:grid-cols-2 gap-6"
                >

                    <div>
                        <label className="block mb-2 font-medium">
                            Name
                        </label>

                        <input
                            type="text"
                            name="name"
                            value={candidate.name}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Email
                        </label>

                        <input
                            type="email"
                            name="email"
                            value={candidate.email}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Phone
                        </label>

                        <input
                            type="text"
                            name="phone"
                            value={candidate.phone}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Qualification
                        </label>

                        <input
                            type="text"
                            name="qualification"
                            value={candidate.qualification}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Experience
                        </label>

                        <input
                            type="text"
                            name="experience_years"
                            value={candidate.experience_years}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Location
                        </label>

                        <input
                            type="text"
                            name="location"
                            value={candidate.location}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">
                            Skills
                        </label>

                        <textarea
                            rows="3"
                            name="skills"
                            value={candidate.skills}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">
                            Bio
                        </label>

                        <textarea
                            rows="4"
                            name="bio"
                            value={candidate.bio}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="md:col-span-2 flex justify-end gap-4">

                        <button
                            type="button"
                            onClick={() => navigate("/admin/candidates")}
                            className="px-6 py-3 rounded-xl bg-gray-200 hover:bg-gray-300"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-3 rounded-xl bg-teal-600 text-white hover:bg-teal-700"
                        >
                            Update Candidate
                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

};

export default EditCandidate;